const it = {
    open_today: 'Aperto Oggi', // 今天开放时间
    close_door: 'chiudere la porta', // 今天关门
    select_service: 'Seleziona il servizio', // 预约服务项目
    //选中
    selected: 'Selezionato',
    //未选中
    unselected: 'Seleziona',
    //店家所在地
    store_address: 'Indirizzo del negozio',
    //一键导航
    navigate: 'Navigazione',
    //去预约
    go_to_booking: 'Prenotare',
    // 返回服务列表
    back_to_service_list: 'Torna alla lista dei servizi',
    //预约信息
    booking_info: 'Informazioni sulla prenotazione',
    //已选服务
    selected_service: 'Numero di servizi selezionati',
    //总计
    total: 'Totale',
    //选择预约时间
    select_booking_time: 'Seleziona l’orario d ll’appuntamento',
    //选择预约日期
    select_booking_data: 'Seleziona la data dell’appuntamento',
    //预约日期
    booking_date: 'data',
    //预约时间
    booking_time: 'orario',
    //填写客户信息
    fill_customer_info: 'Inserisci le informazioni del cliente',
    //姓名
    name: 'Nome',
    //请输入姓名
    please_input_name: 'Inserisci il nome',
    //电话
    phone: 'numero di telefono',
    //请输入电话
    please_input_phone: 'Inserisci il numero di telefono',
    //邮箱
    email: 'Email',
    //选填，请输入邮箱
    please_input_email: 'Inserisci la tua email (Facoltativo)',
    //备注
    remark: 'Note',
    //选填，请填写您的特殊需求或其他备注信息
    please_input_remark: 'Inserisci la nota',
    //确认预约
    confirm_your_reservation: 'Conferma la tua prenotazione',
    //取消预约
    cancel_reservation: 'Annulla la prenotazione',
    //修改预约
    modify_reservation: 'Modifica la prenotazione',
    // 取消编辑
    cancel_edit: 'cancellare',
    // 保存修改
    save_edit: 'salva le modifiche',
    //请选择日期
    please_select_date: 'Seleziona la data',
    //请选择时间
    please_select_time: 'Seleziona l’orario',
    // 隐私协议
    privacy_policy: 'Privacy Policy',
    //确定
    confirm: 'Conferma',
    //取消
    cancel: 'Annulla',
    // 选择至少一项服务
    Select_at_least_one_service: 'scegli almeno un servizio',
    // 服务评价
    service_evaluation: 'valutazione del servizio',
    // 服务名称
    service_name: 'nome del servizio',
    // 服务类别
    service_category: 'categoria del servizio',
    // 服务人员
    service_staff: 'personale del servizio',
    // 价格
    service_price: 'prezzo del servizio',
    // 预约时间
    service_time: 'orario dell’appuntamento',
    // 您的评价
    your_evaluation: 'la tua valutazione',
    // 服务评分
    service_rating: 'valutazione del servizio',
    //请选择评价
    Please_select_a_review: 'Seleziona una recensione',
    //评价内容
    evaluation_content: 'contenuto della valutazione',
    //请输入您对此次服务的评价
    please_input_evaluation: 'Inserisci la tua valutazione',
    // 提交评价
    submit_evaluation: 'Invia la tua valutazione',
    // 感谢您的评论
    thank_you_for_your_comment: 'Grazie per la tua recensione'
}

export default it
